
import { djangoApi, loginRequest, saveSession, getProfile } from "./auth";

/**
 * Authenticate an institute using Django's existing JWT endpoint.
 * This deliberately does not use the old JSON-server institute login.
 */

export async function instituteLogin(email, password) {
  const response = await loginRequest(email, password);
  const tokens = response.data;

  if (!tokens?.access || !tokens?.refresh) {
    throw new Error("The server did not return valid login tokens.");
  }

  saveSession({
    access: tokens.access,
    refresh: tokens.refresh,
  });

  try {
    const profileResponse = await getProfile();
    const profile = profileResponse.data;

    if (!profile?.institute_profile) {
      throw new Error("This account is not linked to an institute.");
    }

    return {
      ...profile.institute_profile,
      id: profile.institute_profile.id,
      userId: profile.id,
      name:
        profile.institute_profile.name ||
        profile.institute_profile.institute_name ||
        profile.username,
      email: profile.email,

      // Used by the login page to decide where to redirect.
      mustChangePassword: Boolean(
        profile.institute_profile.must_change_password
      ),
    };
  } catch (error) {
    const { clearAuth } = await import("./auth");
    clearAuth();
    throw error;
  }
}


export const getInstituteStudents = () =>
  djangoApi.get("/api/auth/institute/students/");

export const addInstituteStudent = (student) =>
  djangoApi.post("/api/auth/institute/students/", student);

export const bulkAddInstituteStudents = (students) =>
  djangoApi.post("/api/auth/institute/students/bulk/", { students });

export const deleteStudent = (studentId) =>
  djangoApi.delete(`/api/auth/institute/students/${studentId}/`);

export const getAllPurchases = () =>
  djangoApi.get("/api/auth/institute/registrations/");

export const getAllScores = () =>
  djangoApi.get("/api/auth/institute/results/");

/**
 * Temporary passwords are generated by Django and emailed to students.
 */
export const generatePassword = () => {
  throw new Error(
    "Temporary passwords are generated by the Django backend."
  );
};



/**
 * Institute payment APIs
 */

// Fetch this institute's payment transaction history.
export const getInstitutePayments = () =>
  djangoApi.get("/api/payments/institute/");

// Submit manual UPI or bank-transfer payment details.
// `formData` should contain payment_method, transaction_reference,
// registration_ids (as a JSON string), and optional payment_proof.
export const submitInstitutePayment = (formData) =>
  djangoApi.post("/api/payments/institute/", formData);

// Fetch registrations for the logged-in institute.
// Existing getAllPurchases() can also be used for this.
export const getInstitutePaymentRegistrations = () =>
  djangoApi.get("/api/auth/institute/registrations/")

export const getInstituteAvailableExams = () =>
  djangoApi.get("/api/auth/institute/exams/");

export const getInstituteSchedulingRegistrations = () =>
  djangoApi.get("/api/auth/institute/scheduling/");

export const bulkScheduleInstituteRegistrations = (payload) =>
  djangoApi.post("/api/auth/institute/scheduling/", payload);
